import * as actionConstants from '../actionConstants';

export const setAccessibility = accessibility => async dispatch => {
  dispatch({ type: actionConstants.SET_ACCESSIBILITY, payload: accessibility });
};

export const setLanguage = language => async dispatch => {
  dispatch({ type: actionConstants.SET_LANGUAGE, payload: language });
};
